

import Vue from 'vue'
import router from '@/router'
import ClienteAPI from '@/api/clientes/clientes'

export default {
  namespaced: true,
  state: {
    clientes: [],
    paginacion: {
      count: 0,
      page: 1,
      page_size: 10,
      next: null,
      previous: null,
    },
    cliente_selected_update: null
  },
  mutations: {
    setClientes(state, data) {
      state.clientes = data
    },
    setPaginacion(state, data) {
      state.paginacion = { ...state.paginacion, ...data };
    },
    clearClientes(state) {
      state.clientes = []
      state.paginacion = { count: 0, page: 1, page_size: 10, next: null, previous: null }
    },
    setClienteUpdate(state, data) {
      state.cliente_selected_update = data
    },

    addCliente(state, cliente) {
      state.clientes.push(cliente)

    },
    quitCliente(state, id) {
      for (var i in state.clientes) {

        if (state.clientes[i].id == id) {

          state.clientes.splice(i, 1);

          break;
        }
      }
    },

    updateCliente(state, cliente) {

      for (var i in state.clientes) {

        if (state.clientes[i].id == cliente.id) {

          state.clientes.splice(i, 1);


          state.clientes.push(cliente)


          break; //Stop this loop, we found it!
        }
      }

    }
  },

  getters: {
    clientes(state) {
      return state.clientes
    },

  },
  actions: {

    async fetchClientes({ commit }, { page = 1, search = "" } = {}) {
      const params = { page };
      if (search) params.search = search;
      console.log(params);


      const res = await ClienteAPI.index(params);

      commit("setClientes", res.data.results);
      commit("setPaginacion", {
        count: res.data.count,
        next: res.data.next,
        previous: res.data.previous,
        page,
      });
    },

    async get_cliente(context, id) {

      var url = `/clientes/cliente/${id}`;

      const cliente = await Vue.axios({
        method: 'GET',
        url: url
      })
      context.commit('setClienteUpdate', cliente.data)



    },
    async actualizar_cliente(context, cliente) {

      const clientes = await ClienteAPI.update(cliente)

      context.commit('updateCliente', clientes.data)
    },

    async registrar_cliente(context, cliente) {
      await ClienteAPI.create(cliente)


      context.dispatch('fetchClientes')

    },

    // Alta con lo mínimo. No pasa por GestorCliente, así que no exige plan de
    // cuentas: el rubro y las cuentas se asignan solos en la primera venta.
    async registrar_cliente_rapido(context, cliente) {
      const res = await ClienteAPI.createRapido(cliente)
      context.dispatch('fetchClientes')
      return res.data
    },
    async actualizar_cliente_contable(context, cliente) {
      await ClienteAPI.updateContable(cliente)
      context.dispatch('fetchClientes')

    },

    // Devuelve lo que respondió el backend: si el cliente se archivó o se
    // eliminó lo decide él, no la pantalla. Antes se tragaba el error y
    // navegaba a una ruta 'clientes' que no existe en ningún contexto.
    async eliminar_cliente(context, id) {
      const res = await ClienteAPI.delete(id)
      context.dispatch('fetchClientes')
      return res.data
    },


  }
}